import { render, staticRenderFns } from "./ClassicTabButton.vue?vue&type=template&id=48d1e610&scoped=true&"
import script from "./ClassicTabButton.vue?vue&type=script&lang=js&"
export * from "./ClassicTabButton.vue?vue&type=script&lang=js&"
import style0 from "./ClassicTabButton.vue?vue&type=style&index=0&id=48d1e610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d1e610",
  null
  
)

export default component.exports